import { render } from "./TicketRecordView.vue?vue&type=template&id=b2a1fe84&scoped=true"
import script from "./TicketRecordView.vue?vue&type=script&lang=js"
export * from "./TicketRecordView.vue?vue&type=script&lang=js"

import "./TicketRecordView.vue?vue&type=style&index=0&id=b2a1fe84&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b2a1fe84"]])

export default __exports__